module.exports = {
	"ru": {
		"Connection lost": "Соединение потеряно",
		"Connecting": "Подключение",
		"Connection established": "Соединение установлено",
		"Session expired": "Сессия истекла",
		"Retrying in": "Повторная попытка через",
		"retry": "Повторить",
		"second(s)": "секунд(ы)"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/ConnectionBar.strings.yaml
// module id = 776
// module chunks = 0